import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { notifyOffline } from '../offline/actions';
import { isOffline } from '../offline/reducer';

const OfflineBanner = ({ offline }) =>
  offline ? (
    <div className='ncss-container bg-accent mb2-sm offline-section text-color-primary-light u-align-center'>
      <span className='headline-4 u-sm-ib pr4-sm pl4-sm'>
        <i className='g72-alert' />
      </span>
      <span className='u-bold'>OFFLINE MODE</span>
      <span className='pl2-sm'>functionality may be limited</span>
    </div>
  ) : null;

OfflineBanner.propTypes = {
  offline: PropTypes.bool.isRequired
};

export default connect(
  state => ({
    offline: isOffline(state)
  }),
  { notifyOffline }
)(OfflineBanner);
